import { send } from 'server';

export const getLeaderboardsList = () => send({
    ID: 71022,
    responses: [71023, 71024],
    description: 'Get player\'s active leaderboards list',
    filterByStatus: ['ACTIVE', 'NOT_STARTED'],
    gamingContext: {
        clientType: 'casino',
        clientPlatform: 'web'
    }
});
